var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"mb-3",attrs:{"onChange":function (e) { return _vm.selected(e); },"options":_vm.books,"value":_vm.selectedBook,"label":"title","placeholder":"Notebook type"}})}
var staticRenderFns = []

export { render, staticRenderFns }